import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthenticated: !!localStorage.getItem("AuthToken"),
  user: null,
  token: localStorage.getItem("AuthToken") || null,
  loading: true
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess(state, action) {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.loading = false;
      const expirationTime = new Date().getTime() + 2 * 60 * 60 * 1000;
      localStorage.setItem("AuthToken", action.payload);
      localStorage.setItem("TokenExpiration", expirationTime.toString());
    },
    logoutSuccess(state) {
      state.loading = false;
      state.isAuthenticated = false;
      state.user = null;
      localStorage.removeItem("AuthToken");
      localStorage.removeItem("TokenExpiration");
      localStorage.removeItem("NsAppPages");
      localStorage.removeItem("UserCoordinates");
    },
    checkComplete(state) {
      state.loading = false;
    }
  },
});

export const { loginSuccess, logoutSuccess } = authSlice.actions;
export default authSlice.reducer;